/* Silent Tank videos: lazy source, no overlay controls, pause outside viewport. */
(() => {
  if (window.slTankSilentVideos) return;
  window.slTankSilentVideos = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const visible = new Set();
  const play = video => {
    if (document.hidden || reduced.matches || !visible.has(video)) return;
    video.muted = true;
    video.defaultMuted = true;
    if (!video.getAttribute('src')) {
      video.src = video.dataset.src;
      video.load();
    }
    video.play().catch(() => {});
  };
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    const video = entry.target;
    if (entry.isIntersecting && entry.intersectionRatio >= .25) {
      visible.add(video); play(video);
    } else { visible.delete(video); video.pause(); }
  }), {threshold: [0,.25]});
  const init = root => root.querySelectorAll('[data-sl-tank-silent]:not([data-sl-video-ready])').forEach(video => {
    video.dataset.slVideoReady = 'true';
    video.muted = true; video.defaultMuted = true; video.controls = false;
    observer.observe(video);
  });
  document.addEventListener('visibilitychange', () => visible.forEach(video => document.hidden ? video.pause() : play(video)));
  reduced.addEventListener('change', () => visible.forEach(video => reduced.matches ? video.pause() : play(video)));
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-sl-tank-silent]').forEach(video => {
    observer.unobserve(video); visible.delete(video); video.pause();
  }));
  init(document);
})();
